import {
	createRouter,
	createWebHistory,
} from 'vue-router'

const routes = [{
		path: '/',
		name: 'Home',
		component: () => import("../views/home"),
		meta: {
			title: 'ISTERO真愛證書查詢系統'
		}
	}, {
		path: '/cert',
		name: 'cert',
		component: () => import("../views/cert"),
		meta: {
			title: 'ISTERO真愛證書'
		}
	},  {
		path: '/404',
		name: '404',
		component: () => import("../views/404"),
		meta: {
			title: '404  - ISTERO WEB SERVICE'
		}
	},
	{
		path: '/:pathMatch(.*)',
		redirect: '/404',
		hidden: true
	}
]

const router = createRouter({
	history: createWebHistory(),
	routes
})

router.beforeEach((to, from, next) => {
	window.scrollTo(0, 0);
	window.document.title = to.meta.title
	next()
})


export default router